import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { useEffect, useRef } from 'react';
import { useMappingService, useTrackingService } from './serviceHooks';

export const useProductViewTracker = (itemId: string | undefined, defaultSizeValue: string | undefined, request: IRequestContext) => {
    if (typeof window === 'undefined') {
        return;
    }

    const lastTrackedVariantRef = useRef<string | undefined>();
    const relewiseTrackingService = useTrackingService(request);
    const relewiseMappingService = useMappingService(request);
    const search = window.location.search ?? '';

    useEffect(() => {
        if (!itemId) {
            return;
        }

        const params = new URLSearchParams(search);
        const color = params.get('color');
        const size = params.get('size') ?? defaultSizeValue;
        const hasVariant = !!color && !!size;

        if (hasVariant) {
            const relewiseVariantId = relewiseMappingService.mapProductDimensionsToRelewiseVariantId(itemId, color, size);
            if (relewiseVariantId !== lastTrackedVariantRef.current) {
                relewiseTrackingService.trackProductView(relewiseMappingService.prefixId(itemId), relewiseVariantId);
            }
            lastTrackedVariantRef.current = relewiseVariantId;
        }
    }, [itemId, search, defaultSizeValue, relewiseTrackingService, relewiseMappingService]);
};
